// src/App.js
import React, { useRef } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { CartProvider } from "./cart/CartContext";
import { AuthProvider } from "./auth/AuthContext";

// Components & Pages
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import TermsIconAdvanced from "./components/TermsIconAdvanced";

import Home from "./pages/Home";
import About from "./pages/About";
import Services from "./pages/Services";
import Gallery from "./pages/Gallery";
import FAQ from "./pages/FAQ";
import Testimonials from "./pages/Testimonials";
import Contact from "./pages/Contact";
import Success from "./pages/Success";
import WeddingPage from "./pages/WeddingPage";
import DesignPage from "./pages/DesignPage";
import DestinationPage from "./pages/DestinationPage";
import EntertainmentPage from "./pages/EntertainmentPage";
import OtherServicesPage from "./pages/OtherServicesPage";
import CartPage from "./pages/CartPage";
import Login from "./pages/Login";
import Register from "./pages/Register";
import ProfilePage from "./pages/ProfilePage";
import GalleryFull from "./pages/GalleryFull";

import ScrollToTop from "./components/ScrollToTop";

// Home layout (Navbar + page sections + Footer)
const HomeLayout = () => {
  // One global instance of the Terms modal
  const termsRef = useRef(null);

  return (
    <>
      {/* Floating 📜 button on the LEFT; expose ref to open from Footer */}
      <TermsIconAdvanced ref={termsRef} trigger="fab" side="left" />

      <Navbar />

      <main>
        <section id="home">
          <Home />
        </section>
        <section id="services">
          <Services />
        </section>
        <section id="about">
          <About />
        </section>
        <section id="gallery">
          <Gallery />
        </section>
        <section id="testimonials">
          <Testimonials />
        </section>
        <section id="faq">
          <FAQ />
        </section>
        <section id="contact">
          <Contact />
        </section>
      </main>

      {/* Wire footer “Terms” to open the modal */}
      <Footer openTerms={() => termsRef.current?.openTo("introduction")} />
    </>
  );
};

function App() {
  return (
    <AuthProvider>
      <CartProvider>
        <Router>
          <ScrollToTop />
          <Routes>
            <Route path="/" element={<HomeLayout />} />
            <Route path="/wedding" element={<WeddingPage />} />
            <Route path="/design" element={<DesignPage />} />
            <Route path="/destination" element={<DestinationPage />} />
            <Route path="/entertainment" element={<EntertainmentPage />} />
            <Route path="/others" element={<OtherServicesPage />} />
            <Route path="/gallery-full" element={<GalleryFull />} />
            <Route path="/cart" element={<CartPage />} />
            <Route path="/success" element={<Success />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/profile" element={<ProfilePage />} />
            <Route path="/orders" element={<ProfilePage />} />
          </Routes>
        </Router>
      </CartProvider>
    </AuthProvider>
  );
}

export default App;
